import { CONTAINER_TYPES, DATE_UNITS, REL_ELEM, REL_LABL, REL_PLAN } from "./structure";

export const migrationEnabled = true;

function toNewPPtr(oldPPtr) {
  const newPPtr = { seq: oldPPtr.seq };

  if (!oldPPtr.parentKey || !oldPPtr.parentClass) {
    if (oldPPtr.key) {
      newPPtr.key = oldPPtr.key;
      return newPPtr;
    }
    console.error("malformed relation:", oldPPtr);
    return;
  }
  if (oldPPtr.parentKey === "root:lists") {
    newPPtr.key = "root:list";
  } else if (oldPPtr.parentKey === "root:periods") {
    newPPtr.key = "root:period";
  } else if (
    oldPPtr.parentKey === "backlog" ||
    DATE_UNITS.includes(oldPPtr.parentClass)
  ) {
    newPPtr.key = oldPPtr.parentClass + ":" + oldPPtr.parentKey;
  } else {
    newPPtr.key = oldPPtr.parentKey;
  }
  return newPPtr;
}

export function migrateFromOldFormat(obj, db) {
  if (
    obj.noMigration ||
    !obj._id ||
    obj._id.startsWith(".") ||
    obj._id === "settings" ||
    obj._id === "statistics" ||
    obj.type === "event"
  )
    return;

  if (obj.type === "list" && obj.relation === "plannedFor") obj.type = "period";
  if (obj._id.startsWith("label:") && !obj.subtaskOf) {
    obj.subtaskOf = { parentClass: "root", parentKey: "root:label", seq: "J" };
  }

  if (obj.relation === "plannedFor") {
    obj.childRel = REL_PLAN;
  } else if (obj.relation === "subtaskOf") {
    obj.childRel = REL_ELEM;
  } else if (!obj.relation) {
    if (obj.type === "period") {
      obj.childRel = REL_PLAN;
    } else if (obj.type === "label") {
      obj.childRel = REL_LABL;
    } else {
      obj.childRel = REL_ELEM;
    }
  } else {
    console.warn(
      "strange relation:",
      obj._id,
      (obj.name || "").slice(0, 30),
      obj.relation,
    );
  }

  if (obj.subtaskOf) {
    if (obj.subtaskOf.parentKey === "list:" + db.name) {
      // no default parent in new version
      obj[REL_ELEM] = undefined;
    } else {
      obj[REL_ELEM] = toNewPPtr(obj.subtaskOf);
    }
  } else {
    if ([...CONTAINER_TYPES, "layout"].includes(obj.type)) {
      obj[REL_ELEM] = {
        key: `root:${obj.type}`,
        seq: "m",
      };
    } else if (!["root", "date", "calendar", "dateUnit"].includes(obj.type)) {
      console.warn(
        "strange object:",
        obj._id,
        (obj.name || "").slice(0, 30),
        obj.relation,
      );
    }
  }

  if (obj.labels) {
    if (Array.isArray(obj.labels)) {
      obj[REL_LABL] = {};
      for (const id of obj.labels) {
        obj[REL_LABL][id] = {};
      }
    } else {
      console.warn(`strange labels for item ${obj._id}: ${JSON.stringify(obj.labels)}`);
    }
  }

  if (obj.plannedFor) obj[REL_PLAN] = toNewPPtr(obj.plannedFor);

  if (!obj.type) {
    console.warn("object without a type:", obj._id, obj.name)
    obj.type = "note"
  }
}

function toOldPPtr(newPPtr) {
  const oldPPtr = { seq: newPPtr.seq };
  const parts = newPPtr.key.split(":");
  oldPPtr.parentClass = parts[0];
  if (DATE_UNITS.includes(parts[0]) || parts[1] === "backlog") {
    oldPPtr.parentKey = parts[1];
  } else {
    oldPPtr.parentKey = newPPtr.key;
  }
  return oldPPtr;
}

export function migrateToOldFormat(obj, db) {
  if (
    obj.noMigration ||
    !obj._id ||
    obj._id.startsWith(".") ||
    obj._id === "settings" ||
    obj._id === "statistics" ||
    obj.type === "event" ||
    obj.type === "label"
  )
    return obj;

  const clone = Object.assign({}, obj);

  if (obj[REL_ELEM]) {
    clone.subtaskOf = toOldPPtr(obj[REL_ELEM]);
  } else {
    // set default list as parent
    clone.subtaskOf = {
      parentKey: "list:" + db.name,
      parentClass: "list",
    };
  }

  if (obj[REL_PLAN]) {
    clone.plannedFor = toOldPPtr(obj[REL_PLAN]);
  } else {
    clone.plannedFor = undefined;
  }

  if (obj[REL_LABL]) {
    clone.labels = [...Object.keys(obj[REL_LABL])];
  } else {
    clone.labels = undefined;
  }

  if (obj.childRel) {
    clone.relation = obj.childRel === REL_ELEM ? "subtaskOf" : "plannedFor";
  }

  return clone;
}
